export default __webpack_public_path__ + "static/media/valleyPort12.3f47f6d7.png";